import { loadScript } from '../../../helpers/commonHelper';

async function getDeviceFingerPrint(processEnv) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return loadScript(`${processEnv.REACT_APP_VISITOR_PROVIDER_CDN_URL}`)
      .then(async () => {
        // @ts-ignore
        const paywallVisitorProvider = window.PaywallVisitorProvider;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return paywallVisitorProvider.init(`${processEnv.REACT_APP_VISITOR_LIB_CDN_URL}`).getVisitorId();
      })
      .catch(() => undefined);
  } catch (e) {
    return Promise.resolve(undefined);
  }
}

export default getDeviceFingerPrint;
